
import { useNavigate } from 'react-router-dom';

interface QuickActionsProps {
  userRole: string;
}

export default function QuickActions({ userRole }: QuickActionsProps) {
  const navigate = useNavigate();

  const actions = [
    {
      id: 'workspace',
      name: '智能工作台',
      description: '嵌入页面 + AI助手',
      icon: 'ri-window-line',
      color: 'bg-gradient-to-r from-purple-500 to-pink-500',
      roles: ['战略管理', '经营管理负责人', '运营负责人', '经理', '员工', 'admin', 'manager', 'employee'],
      onClick: () => navigate('/workspace')
    },
    {
      id: 'profile',
      name: '个人资料',
      description: '查看和编辑个人信息',
      icon: 'ri-user-settings-line',
      color: 'bg-gradient-to-r from-blue-500 to-cyan-500',
      roles: ['战略管理', '经营管理负责人', '运营负责人', '经理', '员工', 'admin', 'manager', 'employee'],
      onClick: () => navigate('/profile')
    },
    {
      id: 'tool-detail',
      name: '智能助手',
      description: 'AI工作汇报助手',
      icon: 'ri-robot-line',
      color: 'bg-gradient-to-r from-green-500 to-teal-500',
      roles: ['战略管理', '经营管理负责人', '运营负责人', '经理', '员工', 'admin', 'manager', 'employee'],
      onClick: () => {
        const userName = localStorage.getItem('userName') || '用户';
        navigate('/tool-detail?toolName=智能工作汇报助手&functionName=智能汇报生成&role=' + encodeURIComponent(userRole) + '&user=' + encodeURIComponent(userName));
      }
    },
    {
      id: 'sale-calendar',
      name: '销售日历',
      description: '管理销售计划和客户跟进',
      icon: 'ri-calendar-line',
      color: 'bg-gradient-to-r from-orange-500 to-red-500',
      roles: ['战略管理', '经营管理负责人', '运营负责人', '经理', '员工', 'admin', 'manager', 'employee'],
      onClick: () => navigate('/sale-calendar')
    }
  ];

  const filteredActions = actions.filter(action => action.roles.includes(userRole || 'employee'));

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
      <h3 className="text-lg font-semibold text-gray-900 mb-4">快速操作</h3>
      
      <div className="space-y-3">
        {filteredActions.map((action) => (
          <button
            key={action.name}
            onClick={action.onClick}
            className="w-full flex items-center space-x-3 p-3 rounded-lg hover:bg-gray-50 transition-colors text-left cursor-pointer"
          >
            <div className={`w-10 h-10 ${action.color} rounded-lg flex items-center justify-center`}>
              <i className={`${action.icon} text-white text-lg`}></i>
            </div>
            <div className="flex-1">
              <div className="font-medium text-gray-900">{action.name}</div>
              <div className="text-sm text-gray-500">{action.description}</div>
            </div>
          </button>
        ))}
      </div>

      <div className="mt-6 pt-6 border-t border-gray-200">
        <div className="flex items-center justify-between mb-3">
          <h4 className="font-medium text-gray-900">今日统计</h4>
        </div>
        
        <div className="space-y-3">
          <div className="flex items-center justify-between">
            <span className="text-sm text-gray-600">待办任务</span>
            <span className="text-sm font-medium text-gray-900">8</span>
          </div>
          <div className="flex items-center justify-between">
            <span className="text-sm text-gray-600">已完成</span>
            <span className="text-sm font-medium text-green-600">12</span>
          </div>
          <div className="flex items-center justify-between">
            <span className="text-sm text-gray-600">进行中</span>
            <span className="text-sm font-medium text-blue-600">5</span>
          </div>
        </div>
      </div>
    </div>
  );
}
